<!-- Page Wrapper -->
<!-- <div class="page-wrapper" style="min-height: 347px;"> -->
<div class="content container-fluid">
    <div class="bg-white page-border">

        <!--header row-->
        <div class="row row-replace add-m-b">
            <!-- header  -->
            <div class="col-12 col-p text-center">
                <div class="row">
                    <div class="col-8 col-md-10">
                        <img src="assets/img/logo.png" class="mb-5" width="180">
                    </div>
                    <div class="col-4 col-md-2" *ngIf="empStatus == 'ex' || empStatus == ''">
                        <button class="btn btn-sm btn-danger" (click)="logout()">
                       LogOut
                      </button>
                    </div>
                </div>
                <hr/>
                <div class="row">

                </div>
            </div>
        </div>

        <!--page body contant -->
        <!-- header  -->
        <div class="row row-replace add-m-b">
            <div class="col-md-7 col-9 col-p h5">REQUEST FORM</div>
            <div class="col-md-5 col-3 top-corner-items col-p">
                <button class="btn btn-primary btn-sm" (click)="back()"><i class="fa fa-arrow-left"></i> Back</button>
            </div>
        </div>
        <!--end header row -->
        <div class="container-fluid">



            <ul class="nav nav-tabs nav-tabs-bottom">
                <li class="nav-item"><a class="nav-link active" (click)="changeEvent('a')" href="#ticket-tab1" data-toggle="tab">Create Query</a></li>
                <li class="nav-item"><a class="nav-link" (click)="changeEvent('b')" href="#ticket-tab2" data-toggle="tab">My Queries</a></li>

            </ul>

            <div class="tab-content">
                <nav class="tab-pane active" id="ticket-tab1">
                    <app-create-alumni-query *ngIf="vewCmt.a"></app-create-alumni-query>

                </nav>
                <nav class="tab-pane" id="ticket-tab2">
                    <app-view-alumni-query [empId]="empId" *ngIf="empId && vewCmt.b"></app-view-alumni-query>
                </nav>


            </div>

        </div>


        <!--end page body contant -->
    </div>
</div>
<!-- </div> -->

<!-- /Page Wrapper -->